import React from 'react';
import Toast from 'react-bootstrap/Toast';
import { toastBanner, toastButton } from './Styles';

export default function ToastMessage(props) {
  return (
    <Toast onClose={props.toggleToast} show={props.showToast}
      animation={false} delay={5000} style={toastBanner} autohide>
      <Toast.Header style={props.toastType} closeButton={false}>
        <span className="mr-auto">{props.message}</span>
        <button type="button" className="close ml-2 mb-1" onClick={props.toggleToast}
          style={toastButton}
          data-dismiss="toast">
          <span aria-hidden="true">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Toast.Header>
    </Toast>
  );
}